exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".completion-box[data-v-194b00e2]{border-bottom:1px solid #494949;padding:.5rem 1rem}.completion-box.overdue[data-v-194b00e2]{background-color:red}#main[data-v-194b00e2]{border:1px solid #494949}.parent[data-v-194b00e2]{position:relative;border-left:2px solid;padding-bottom:.6rem}.parent.dashed[data-v-194b00e2]{border-left-style:dashed}.dot[data-v-194b00e2]{height:10px;width:10px;border-radius:50%;position:absolute;display:inline-block}.dot.full[data-v-194b00e2]{background-color:#fff;top:4px;left:-6px}.dot.outlined[data-v-194b00e2]{border:2px solid #fff;background-color:#303030;top:5px;left:-6px}.arrow[data-v-194b00e2]{color:transparent;border:solid #fff;border-width:0 2px 2px 0;height:10px;width:10px;position:absolute;top:0;left:-33px;display:inline-block;transform:rotate(45deg)}.v-card.v-picker[data-v-194b00e2]{box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-194b00e2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Job/Timeline.vue
// module id = 365
// module chunks = 0